import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Label } from '../components/ui/Label';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';

const ProfilePage = () => {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({ firstName: '', lastName: '', company: '', phone: '' });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        company: user.company || '',
        phone: user.phone || '',
      });
    }
  }, [user]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const next = {};
    if (form.firstName && form.firstName.trim().length < 2) next.firstName = 'At least 2 characters';
    if (form.lastName && form.lastName.trim().length < 2) next.lastName = 'At least 2 characters';
    if (form.company && form.company.trim().length > 100) next.company = 'Max 100 characters';
    if (form.phone && !/^\+?[1-9][\d]{0,15}$/.test(form.phone.trim())) next.phone = 'Invalid phone number';
    return next;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (Object.keys(v).length) { setErrors(v); return; }
    setSaving(true);
    try {
      await updateUser({
        firstName: form.firstName.trim() || undefined,
        lastName: form.lastName.trim() || undefined,
        company: form.company.trim() || undefined,
        phone: form.phone.trim() || undefined,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Profile</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <form className="space-y-6" onSubmit={onSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="firstName" className="mb-2 block">First Name</Label>
              <Input id="firstName" name="firstName" value={form.firstName} onChange={onChange} placeholder="First name" />
              {errors.firstName && <p className="mt-2 text-sm text-red-600">{errors.firstName}</p>}
            </div>
            <div>
              <Label htmlFor="lastName" className="mb-2 block">Last Name</Label>
              <Input id="lastName" name="lastName" value={form.lastName} onChange={onChange} placeholder="Last name" />
              {errors.lastName && <p className="mt-2 text-sm text-red-600">{errors.lastName}</p>}
            </div>
          </div>

          <div>
            <Label htmlFor="company" className="mb-2 block">Company</Label>
            <Input id="company" name="company" value={form.company} onChange={onChange} placeholder="Company" />
            {errors.company && <p className="mt-2 text-sm text-red-600">{errors.company}</p>}
          </div>

          <div>
            <Label htmlFor="phone" className="mb-2 block">Phone</Label>
            <Input id="phone" name="phone" type="tel" value={form.phone} onChange={onChange} placeholder="+1 555 123 4567" />
            {errors.phone && <p className="mt-2 text-sm text-red-600">{errors.phone}</p>}
          </div>

          <div className="flex justify-end">
            <Button type="submit" disabled={saving}>
              {saving ? 'Saving...' : 'Save changes'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfilePage;